




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { fetchUserAnnouncement } from '@/appsync/service/AnnouncementQueryService';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  UserInfo,
  LoginInfo,
  UserAnnouncement,
  UserAnnouncementQueryParam,
} from '@/types/type';
import { getDisabledRoutes } from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';
import { REL } from '@/utils/consts';

@Component({
  components: { PortalAppBar, ErrorMessagePageTemplate, PageNotFound },
})
export default class AnnouncementWithId extends Vue {
  private loading: boolean = true;
  private isAnnouncementEnabled: boolean = false;
  private dataCanShow: boolean = false;
  private loginInfo!: LoginInfo;
  private userAnnouncement: UserAnnouncement | null = null;
  private notEnabledImgAltMessage: String = 'Page Not Enabled';
  private notEnabledImgName: String = 'page-not-enabled';
  private notEnabledImgWidth: String = '250px';
  private notEnabledImgHeight: String = '186px';

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    this.loginInfo = loginInfo;
    await refreshStores(loginInfo);

    const disabledRoutes = await getDisabledRoutes(
      loginInfo.tenant,
      loginInfo.landscape,
      loginInfo.loginName
    );

    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.announcementWithId)) {
      this.isAnnouncementEnabled = true;
      const userAnnouncementQueryParam: UserAnnouncementQueryParam = {
        loginName: loginInfo.loginName,
        tenant: loginInfo.tenant,
        landscape: loginInfo.landscape,
        id: this.$route.params.id,
      };
      await fetchUserAnnouncement(userAnnouncementQueryParam).then(
        userAnnouncement => {
          if (userAnnouncement) {
            this.userAnnouncement = userAnnouncement;
            this.dataCanShow = true;
          }
        }
      );
    }
    this.loading = false;
  }

  private get notEnabledTitleText(): string {
    return i18n.tc('pageNotEnabled.titleText');
  }

  private get notEnabledSubText(): string {
    return i18n.tc('pageNotEnabled.subText');
  }

  private get pageTitle(): string {
    return i18n.tc('portal.announcement');
  }

  private get displayPeriodLabel(): string {
    return i18n.tc('announcement.displayPeriodLabel');
  }

  private get contentLabel(): string {
    return i18n.tc('announcement.contentLabel');
  }

  private get updateDateLabel(): string {
    return i18n.tc('announcement.updateDateLabel');
  }

  private get urlLabel(): string {
    return i18n.tc('announcement.urlLabel');
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get displayPeriod(): string {
    if (this.userAnnouncement) {
      return `${this.userAnnouncement.displayStartDate} ~ ${this.userAnnouncement.displayEndDate}`;
    }
    return '';
  }

  private clickUrl(url: string): void {
    window.open(url, REL);
  }
}
